<template>
  <div>
    <ContentLoader
      :height="16"
      :width="320"
      :speed="1"
      primary-color="#f3f3f3"
      secondary-color="#ecebeb"
      class="caption-loader"
    >
      <rect x="0" y="0" rx="4" ry="4" width="150" height="14" />
    </ContentLoader>
  </div>
</template>

<style lang="scss" scoped>

.caption-loader {
  max-width: 320px;
}
</style>

<script>
import { ContentLoader } from 'vue-content-loader';

export default {
  components: {
    ContentLoader,
  },
};
</script>
